import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg<{ direction?: 'left' | 'right' }>`
  width: 1.1em;
  height: 1em;
  /* 방향에 따라 가로 반전 */
  transform: ${({ direction }) => (direction === 'right' ? 'scaleX(-1)' : 'none')};
`;

interface Props extends React.SVGProps<SVGSVGElement> {
  direction?: 'left' | 'right';
}

const IconArrowLong: React.FC<Props> = ({ direction = 'left', className, fontSize, fill, stroke }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    className={className ?? ''}
    fontSize={fontSize ?? '1.8rem'}
    viewBox="0 0 21 19"
    fill={fill ?? 'none'}
    stroke={stroke ?? 'currentColor'}
    direction={direction}
  >
    <path
      d="M1.559 9.54389H19.559
         M1.559 9.54389L9.5206 1.5439
         M1.559 9.54389L9.5206 17.5439"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default IconArrowLong;
